import { render } from "./TrainingForm.vue?vue&type=template&id=23dc7eb5&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import "./TrainingForm.vue?vue&type=style&index=0&id=23dc7eb5&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dc7eb5"]])

export default __exports__